module.exports = __webpack_public_path__ + "static/media/campus_19.bc89461d.png";